<template>
    <core-basic-drop-down
        :items="items"
        :selection.sync="selected"
        noneLabel="- none -"
        noLabel
    ></core-basic-drop-down>
</template>

<script>
export default {
  props: {
    traveler: {
      type: Object,
      required: true
    },
    selectedValue: {
      type: String | Number,
      required: true
    },
    placements: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: this.selectedValue,
      items: this.placements
    }
  },
  watch: {
    selected: {
      handler (val) {
        this.$emit('selected', val, this.traveler)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/travelers/Placement.vue